import React from 'react';
import '../CSS/Profile/BeckyHermanProfile.css';

const BeckyHermanProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/becky-herman-image.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="Becky Herman"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">Becky Herman</h1>
        <div className="profile-title-container">
          <p className="profile-title">Consultant</p>
          <a href="https://www.linkedin.com/in/becky-herman-469a2359/" target="_blank" rel="noopener noreferrer">
            <img 
              src={linkedInIcon}
              alt="LinkedIn"
              className="profile-linkedin-icon"
            />
          </a>
        </div>
        <div className="profile-desc">
          <p>
            <strong>Becky Herman</strong> is an accomplished non-profit leader with over 25 years of experience in healthcare and education. She has a proven track record of driving strategic growth, enhancing constituent engagement, and increasing organizational revenue through innovative fundraising, branding, and outreach strategies. A results-oriented professional, she has excelled in managing cross-functional teams, building strong partnerships, and executing strategic initiatives that align with institutional goals. Her expertise includes fundraising, project and event management, marketing, strategic planning, and process improvement.
          </p>
          <p>
            She currently serves as the Executive Director of the Seventh District and Monroe County Dental Societies in New York State, in addition to her part-time role as a search consultant. Previously, she was the Director of Recruitment and Community Outreach for NYU Langone Dental Medicine, the Director of Alumni Relations and Development for Lutheran Medical Center's Department of Dental Medicine, and the Director of Advancement for the Eastman Institute for Oral Health at the University of Rochester. In this role, she led their comprehensive capital campaign.
          </p>
          <p>
            A graduate of Alfred State College and SUNY Geneseo, with a Bachelor of Arts degree in Communication, Ms. Herman holds a master's degree in Education from the University of Pacific and completed a premier teacher training program through the American Dental Education Association's AAL Institute for Teaching and Learning. She also serves on the Advisory Council for the Monroe Community College Dental Studies Program and is a Board Member of Bridges for Brain Injury, Inc.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BeckyHermanProfile;

